var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectBankAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39344 32.0445H3.33198C2.04406 32.0445 1 33.0886 1 34.3765V37H37V34.3765C37 33.0886 35.9559 32.0445 34.668 32.0445H33.6066M4.39344 32.0445V14.992M4.39344 32.0445H9.55738M4.39344 14.992H9.55738M4.39344 14.992H1V11.7126L19 1L37 11.7126V14.992H33.6066M33.6066 32.0445V14.992M33.6066 32.0445H28.4426M33.6066 14.992H28.4426M28.4426 32.0445V14.992M28.4426 32.0445H21.6557M28.4426 14.992H21.6557M21.6557 32.0445C21.6557 32.0445 21.6557 21.6514 21.6557 14.992M21.6557 32.0445H16.3443M21.6557 14.992H16.3443M16.3443 32.0445V14.992M16.3443 32.0445H9.55738M16.3443 14.992H9.55738M9.55738 32.0445V14.992M21.6557 9.01618C21.6557 10.4651 20.4667 11.6397 19 11.6397C17.5333 11.6397 16.3443 10.4651 16.3443 9.01618C16.3443 7.56727 17.5333 6.3927 19 6.3927C20.4667 6.3927 21.6557 7.56727 21.6557 9.01618Z",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectBankAccount);
export default __webpack_public_path__ + "static/media/connect-bank-account.404a8c588634b4ac1b7f844f8a3550c1.svg";
export { ForwardRef as ReactComponent };